import Link from "next/link"

import type { InvestigationEvidenceItem } from "../utils/investigationFindings"

interface FindingEvidenceListProps {
  evidenceCount: number
  items: InvestigationEvidenceItem[]
  truncated: boolean
}

export function FindingEvidenceList({
  evidenceCount,
  items,
  truncated,
}: FindingEvidenceListProps) {
  return (
    <>
      <ul className="mt-2 space-y-3">
        {items.length === 0 && !truncated && (
          <li className="text-sm text-coval-text-muted">
            The evidence for this finding has expired from retention.
          </li>
        )}
        {items.map((item) => (
          <li
            key={item.evidenceId}
            className="space-y-1 border-l-2 border-coval-border pl-3"
          >
            <blockquote className="text-sm leading-5 text-coval-text">
              &ldquo;{item.quote}&rdquo;
            </blockquote>
            <p className="text-xs text-coval-text-muted">
              {item.speaker} · turn {item.turnIndex}
              {item.metricVerdict ? (
                <> · judge said {item.metricVerdict}</>
              ) : null}
              {item.href ? (
                <>
                  {" · "}
                  <Link
                    href={item.href}
                    className="text-coval-info-text hover:underline"
                  >
                    {item.sourceLabel}
                  </Link>
                </>
              ) : null}
            </p>
          </li>
        ))}
      </ul>
      {truncated ? (
        <p className="px-1 pt-2 text-sm text-coval-text-muted">
          This evidence list reached its page limit; more items may not be
          shown.
        </p>
      ) : items.length > 0 && items.length < evidenceCount ? (
        <p className="px-1 pt-2 text-sm text-coval-text-muted">
          Showing {items.length} of {evidenceCount} evidence items.
        </p>
      ) : null}
    </>
  )
}
